import { Grid, GridItem, HStack, Text, useColorModeValue, VStack } from '@chakra-ui/react';
import type React from 'react';
import { useHomePageColors } from '@/hooks/useHomePageColors';
import { Flag } from '../../components';
import { countriesInfo, Country, type CountryCode } from '@/models/country';
import { HOME_DEMO_10_TEAMS } from './homeDemoExample';

interface DemoTeamListProps {
  withMultipliers?: boolean;
  /** Defaults to the shared home-page example list. */
  teams?: CountryCode[];
}
const DemoTeamList: React.FC<DemoTeamListProps> = (props) => {
  const { withMultipliers = false, teams: teamsProp } = props;
  const teams: CountryCode[] = teamsProp ?? [...HOME_DEMO_10_TEAMS];
  const { surfaceCard, borderStrong } = useHomePageColors();
  const rowDivider = useColorModeValue('rgb(0 0 0 / 20%)', 'whiteAlpha.300');

  return (
    <VStack
      textAlign='center'
      borderWidth='1px'
      borderColor={borderStrong}
      borderRadius='16px'
      bgColor={surfaceCard}
      maxW='95%'
      w={{
        base: '95%',
        md: '100%',
      }}
      px={{
        base: 3,
        md: 3,
      }}
      py={2}
      fontSize={{
        base: '13px',
        md: '15px',
        lg: '18px',
        xl: '20px',
      }}
    >
      {teams.map((team, idx) => (
        <Grid
          key={team}
          w='100%'
          templateColumns={{
            base: withMultipliers ? '16px 2fr 1fr' : '16px 2fr',
            md: withMultipliers ? '40px 3fr 1fr' : '40px 3fr',
          }}
          alignItems='center'
          gap={4}
          borderWidth={idx === teams.length - 1 ? '0' : '1px'}
          borderColor={surfaceCard}
          borderBottomColor={rowDivider}
          py={{ base: 1, md: 2 }}
        >
          <GridItem alignItems='flex-start'>
            <Text
              fontWeight={{
                base: 600,
                md: 700,
              }}
              fontSize={{
                base: '11px',
                md: '15px',
                lg: '18px',
              }}
            >
              {idx + 1}.
            </Text>
          </GridItem>
          <GridItem>
            <HStack
              spacing={{
                base: 2,
                md: 4,
                lg: 8,
              }}
            >
              <Flag
                country={Country[team]}
                w={{ base: '24px', md: '44px' }}
                borderWidth='1px'
                borderColor='gray.100'
                borderRadius={{ base: '4px', md: '8px' }}
              />
              <Text
                fontWeight={700}
                fontSize={{
                  base: '11px',
                  md: '14px',
                  lg: '18px',
                }}
              >
                {countriesInfo[team].name}
              </Text>
            </HStack>
          </GridItem>
          {withMultipliers && (
            <GridItem textAlign='right'>
              <Text
                fontWeight={700}
                fontSize={{
                  base: '15px',
                  md: '20px',
                  lg: '24px',
                }}
              >
                x{teams.length - idx}
              </Text>
            </GridItem>
          )}
        </Grid>
      ))}
    </VStack>
  );
};

export default DemoTeamList;
